import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { selectMediaState } from 'redux/modules/device';
var SET_VISIBLE_VENUES = 'classpass/search/SET_VISIBLE_VENUES';
var SET_CURRENT_PAGE = 'classpass/search/SET_CURRENT_PAGE';
var SET_RELOAD_CURSOR = 'classpass/search/SET_RELOAD_CURSOR';
var SET_SEARCH_ID = 'classpass/search/SET_SEARCH_ID';
var SET_ACTIVE_URL = 'classpass/search/SET_ACTIVE_URL';
var SET_FILTERING_DISABLED = 'classpass/search/SET_FILTERING_DISABLED';
var SET_MAP_VIEW = 'classpass/search/SET_MAP_VIEW';
var SET_FILTERS_FROM_HASH = 'classpass/search/SET_FILTERS_FROM_HASH';
export var TOGGLE_MAP_VIEW = 'classpass/search/TOGGLE_MAP_VIEW';
export var setCurrentPage = function setCurrentPage(value) {
  return {
    type: SET_CURRENT_PAGE,
    key: 'currentPage',
    value: value
  };
};
export var setReloadCursor = function setReloadCursor(value) {
  return {
    type: SET_RELOAD_CURSOR,
    key: 'reloadCursor',
    value: value
  };
};
export var setSearchId = function setSearchId(value) {
  return {
    type: SET_SEARCH_ID,
    key: 'searchId',
    value: value
  };
};
export var setActiveUrl = function setActiveUrl(value) {
  return {
    type: SET_ACTIVE_URL,
    key: 'activeUrl',
    value: value
  };
};
export var setFilteringDisabled = function setFilteringDisabled(value) {
  return {
    type: SET_FILTERING_DISABLED,
    key: 'filteringDisabled',
    value: value
  };
};
export var setupFilters = function setupFilters(filters) {
  return {
    type: SET_FILTERS_FROM_HASH,
    filters: filters
  };
};
export var setVisibleVenues = function setVisibleVenues(value) {
  return {
    type: SET_VISIBLE_VENUES,
    key: 'visibleVenues',
    value: value
  };
};
export var setMapView = function setMapView(value) {
  return {
    type: SET_MAP_VIEW,
    key: 'isMapView',
    value: value
  };
};
export var toggleMapView = function toggleMapView() {
  return {
    type: TOGGLE_MAP_VIEW
  };
};

var selectSearchState = function selectSearchState(state) {
  return state.features.search;
};

export var selectVisibleVenues = function selectVisibleVenues(state) {
  return selectSearchState(state).visibleVenues;
};
export var selectCurrentPage = function selectCurrentPage(state) {
  return selectSearchState(state).currentPage;
};
export var selectReloadCursor = function selectReloadCursor(state) {
  return selectSearchState(state).reloadCursor;
};
export var selectSearchId = function selectSearchId(state) {
  return selectSearchState(state).searchId;
};
export var selectActiveUrl = function selectActiveUrl(state) {
  return selectSearchState(state).activeUrl;
};
export var selectFilteringDisabled = function selectFilteringDisabled(state) {
  return selectSearchState(state).filteringDisabled;
};
export var selectMapView = function selectMapView(state) {
  return selectSearchState(state).isMapView;
};
export var selectIsMapToggleable = function selectIsMapToggleable(state) {
  return !selectMediaState(state).lg;
};
var initialState = {
  currentPage: 1,
  reloadCursor: '',
  searchId: null,
  activeUrl: '',
  filteringDisabled: false,
  isMapView: false,
  visibleVenues: null
};
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_VISIBLE_VENUES:
    case SET_CURRENT_PAGE:
    case SET_RELOAD_CURSOR:
    case SET_SEARCH_ID:
    case SET_ACTIVE_URL:
    case SET_FILTERING_DISABLED:
    case SET_MAP_VIEW:
      return _objectSpread({}, state, _defineProperty({}, action.key, action.value));

    case TOGGLE_MAP_VIEW:
      return _objectSpread({}, state, {
        isMapView: !state.isMapView
      });

    default:
      return state;
  }
}